export enum OrganizationKeyScopes {
    ProjectsRead = 'projects.read',
    ProjectsWrite = 'projects.write',
    OrganizationProjectsKeysRead = 'organization.projects.keys.read',
    OrganizationProjectsKeysWrite = 'organization.projects.keys.write',
    OrganizationInstallationsRead = 'organization.installations.read',
    OrganizationInstallationsWrite = 'organization.installations.write',
    OrganizationMembershipsRead = 'organization.memberships.read',
    OrganizationMembershipsWrite = 'organization.memberships.write',
    OrganizationRead = 'organization.read',
    OrganizationWrite = 'organization.write',
    DomainsRead = 'domains.read',
    DomainsWrite = 'domains.write',
    KeysRead = 'keys.read',
    KeysWrite = 'keys.write',
}
